import React, {useState} from "react";

import IndicatorsList from "./Components/List";
import {useNavigate} from "react-router";
import {SelectIndicator} from "../../components/Select";
import {useUser} from "../../store/providers/app";
import {toast} from "react-toastify";
import {optionsDefault} from "../../utils";
import {debounce} from "lodash";
import {FilterSelectUsers} from "./Components/FilterSelectUsers";

const ListIndicators = () => {

    const navigate = useNavigate();
    const { user } = useUser()

    const date = new Date();
    const currentYear = date.getFullYear();

    const [selectedIndicator, setSelectedIndicator] = useState(null);
    const [selectedStatus, setSelectedStatus] = useState('')
    const [selectedLang, setSelectedLang] = useState('')
    const [searchText, setSearchText] = useState('')
    const [selectedUser, setSelectedUser] = useState('');
    const [yearReference, setYearReference] = useState(currentYear);


    const onChange = (e) => {
        setSearchText(e.target.value)
    }

    const handleChangeUser = (user) => {
        setSelectedUser(user)
    }

    const debouncedOnChange = debounce(onChange, 1000);

    const changeSelect = (newValue, {action}) => {
        switch (action.action) {
            case 'select-option':
                setSelectedIndicator(newValue)
                break
            case 'clear':
                setSelectedIndicator('')
                break
            default:
                return
        }
    };

    if (user.profile !== 1) {
        toast.error('Você não tem permissão para acessar esta área!');
        navigate('/')
    }

    return (
        <section className="content-wrapper mt-3 transition">
            <div className="content">
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-sm-12">

                            <h2 className="text-uppercase fw-light">
                                <i className="bi bi-list-task text-theme"/> Lista de Indicadores
                            </h2>

                            <div className="card mt-3 border-0 shadow-sm">
                                <div className="card-body">
                                    <div className="row g-3">
                                        <div className="col-12 col-md-6">
                                            <SelectIndicator
                                                changeSelect={changeSelect}
                                                selected={selectedIndicator}
                                            />
                                        </div>

                                        <div className="col-12 col-md-3">
                                            <select
                                                className="form-select"
                                                onChange={ (e) => setSelectedStatus(e.target.value) }
                                            >
                                                <option value="">Selecione o status</option>

                                                {selectedLang !== 'en-US' &&
                                                    <optgroup label="Português">
                                                        {optionsDefault.map((option, index) => {

                                                            if (selectedLang) {
                                                                if (selectedLang !== option.lang) return
                                                            }

                                                            if (option.lang === 'pt-BR') {
                                                                return (
                                                                    <option key={index}
                                                                            value={option.value}>{option.label}</option>
                                                                )
                                                            }

                                                            return false

                                                        })}
                                                    </optgroup>
                                                }

                                                {selectedLang !== 'pt-BR' &&

                                                    <optgroup label="Inglês">
                                                        {optionsDefault.map((option, index) => {

                                                            if (selectedLang) {
                                                                if (selectedLang !== option.lang) return
                                                            }

                                                            if (option.lang === 'en-US') {
                                                                return (
                                                                    <option key={index}
                                                                            value={option.value}>{option.label}</option>
                                                                )
                                                            }
                                                            return false
                                                        })}
                                                    </optgroup>
                                                }

                                            </select>
                                        </div>
                                        <div className="col-12 col-md-3">
                                            <select
                                                className="form-select"
                                                onChange={ (e) => setSelectedLang(e.target.value) }
                                            >
                                                <option value="">Todos os idiomas</option>
                                                <option value="pt-BR">Português</option>
                                                <option value="en-US">Inglês</option>
                                            </select>
                                        </div>

                                        <div className="col-12 col-md-6">
                                            <FilterSelectUsers handleChangeUser={handleChangeUser}/>
                                        </div>

                                        <div className="col-12 col-md-3">
                                            <select
                                                className="form-select"
                                                onChange={(e) => setYearReference(e.target.value) }
                                                defaultValue={yearReference}
                                            >
                                                <optgroup label="Ano de publicação">
                                                    <option value="2021">2021</option>
                                                    <option value="2022">2022</option>
                                                    <option value="2023">2023</option>
                                                    <option value="2024">2024</option>
                                                    <option value="2025">2025</option>
                                                </optgroup>
                                            </select>
                                        </div>

                                        <div className="col-12 col-md-3">
                                           <input
                                               className="form-control"
                                               onChange={debouncedOnChange}
                                               placeholder="Palavra chave"
                                           />
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <IndicatorsList
                                selected={selectedIndicator}
                                status={selectedStatus}
                                language={selectedLang}
                                searchText={searchText}
                                selectedUser={selectedUser}
                                yearReference={yearReference}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}

export default ListIndicators
